/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import RequisicionPorId from "components/VistaModulos/RequisicionPorId";
import { useRequisicionIndividual } from "hooks/useRequisicionIndividual";
import CotizacionModal from "components/VistaModulos/Cotizacion";
import { FormikProvider } from "formik";
import { InventarioDetalleContenido, InventarioTabla } from "modules/inventario";
import { IconUserEdit, IconPlaylistAdd, IconShoppingBagPlus } from "@tabler/icons-react";

function RequisicionIndividual(): JSX.Element {
  const userName = useSelector((state: StoreType) => state?.app?.user?.data?.usuario || null);
  const fotoUser: any = useSelector((state: StoreType) => state?.app?.user?.data?.foto || logo);
  const nombreAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.nombre || null
  );
  const apellidosAutorizando = useSelector(
    (state: StoreType) => state?.app?.user?.data?.apellidos || null
  );
  const nombreCompletoAutorizando = nombreAutorizando + " " + apellidosAutorizando;

  const {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    requisicion,
    detallesRequisicionPaginados,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    idUsuario,
    //cotizacion
    procesandoCotizacion,
    //autorizar
    procesandoMandarAutorizar,
    enviarAutorizar,
    procesoAutorizacion,
    //modal para autorizar
    isAlertOpenAutorizar,
    handleisAlertOpenAutorizar,
    handleisAlertCloseAutorizar,
    accionRequisicion,
    setAccionRequisicion,
    handleAccionRequisicion,
    //detalles cotización
    verCotizacion,
    setVerCotizacion,
    isAlertOpenCotizacion,
    handleisAlertOpenCotizacion,
    handleisAlertCloseCotizacion,
    proveedoresPorProducto,
    procesandoProveedores,
    getProveedoresPorProductos,
    crearCotizacion,
    jefeInmediato,
    getJefeInmediato,
    surtirDisponible,
    procesandoSurtir,
    marcarAtendida,
    //crear producto nuevo
    procesandoInventario,
    isAlertOpenCrearInventario,
    handleisAlertCrearInventarioOpen,
    handleisAlertCrearInventarioClose,
    formikInventario,
    getFieldColorInventario,
    unidadesMedida,
    ubicaciones,
    almacenes,
    createInventarioOnRequi,
    procesandoModal,
    setIdDetalleRequisicion,
    idDetalleRequisicion,
    //lista seleccionable de productos
    isAlertOpenListaSeleccionable,
    handleisAlertOpenListaSeleccionable,
    handleisAlertCloseListaSeleccionable,
    filasInventario,
    setProductoDetalle,
    productoDetalle,
    actualizarProductoEnRequisicion,
    categorias,
    tipoProductos,
    cancelarRequisicion,
  } = useRequisicionIndividual();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Grid xs={12}>
                <RequisicionPorId
                  verRequisicion={requisicion}
                  detallesRequisicionPaginados={detallesRequisicionPaginados}
                  procesando={procesando}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  usuarioArjion={userName}
                  procesoAutorizacion={procesoAutorizacion}
                  idUsuario={idUsuario}
                  isAlertOpenAutorizar={isAlertOpenAutorizar}
                  handleisAlertOpenAutorizar={handleisAlertOpenAutorizar}
                  handleisAlertCloseAutorizar={handleisAlertCloseAutorizar}
                  accionRequisicion={accionRequisicion}
                  handleAccionRequisicion={handleAccionRequisicion}
                  procesandoMandarAutorizar={procesandoMandarAutorizar}
                  nombreCompletoAutorizando={nombreCompletoAutorizando}
                  setAccionRequisicion={setAccionRequisicion}
                  handleisAlertOpenCotizacion={handleisAlertOpenCotizacion}
                  setVerCotizacion={setVerCotizacion}
                  getJefeInmediato={getJefeInmediato}
                  jefeInmediato={jefeInmediato}
                  surtirDisponible={surtirDisponible}
                  procesandoSurtir={procesandoSurtir}
                  marcarAtendida={marcarAtendida}
                  cancelarRequisicion={cancelarRequisicion}
                  handleisAlertCrearInventarioOpen={handleisAlertCrearInventarioOpen}
                  setIdDetalleRequisicion={setIdDetalleRequisicion}
                  enviarAutorizar={enviarAutorizar}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}

      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* MODAL PARA COTIZAR */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseCotizacion}
        isOpen={isAlertOpenCotizacion}
        key={"alerta-detalles-cotizacion"}
      >
        {verCotizacion && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <br />
              <br />
              <CotizacionModal
                verCotizacion={verCotizacion}
                procesandoCotizacion={procesandoCotizacion}
                usuarioArjion={userName}
                idUsuario={idUsuario}
                nombreCompletoAutorizando={nombreCompletoAutorizando}
                proveedoresPorProducto={proveedoresPorProducto}
                procesandoProveedores={procesandoProveedores}
                getProveedoresPorProductos={getProveedoresPorProductos}
              />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      {/* MODAL PARA AÑADIR PRODUCTO NUEVO */}
      <ModalComponent
        handleClose={handleisAlertCrearInventarioClose}
        isOpen={isAlertOpenCrearInventario}
        key={"alerta-crear-Inventario"}
        procesando={procesandoModal}
        actions={[
          {
            title: "Añadir producto",
            icon: <IconShoppingBagPlus stroke={2} />,
            color: "#D4AF37",
            hoverColor: "#a98c2c",
            textColor: "#3D3E3D",
            disabledButton: !formikInventario.isValid || procesandoModal,
            handleAction: () => {
              const datos = {
                clave: formikInventario.values.clave,
                nombre: formikInventario.values.nombre,
                precio: formikInventario.values.precio,
                id_unidad_medida: formikInventario.values.id_unidad_medida,
                id_categoria: formikInventario.values.id_categoria,
                id_ubicacion: formikInventario.values.id_ubicacion,
                id_tipo_producto: formikInventario.values.id_tipo_producto,
                cantidad: formikInventario.values.cantidad,
                maximos: formikInventario.values.maximos,
                minimos: formikInventario.values.minimos,
                punto_reorden: formikInventario.values.punto_reorden,
                id_usuario: idUsuario,
                id_requisicion_detalle: idDetalleRequisicion,
              };
              createInventarioOnRequi(datos);
            },
          },
          {
            title: "Seleccionar existente",
            icon: <IconPlaylistAdd stroke={2} />,
            color: "#87CEEB",
            hoverColor: "#6ca4bc",
            textColor: "#041d45",
            handleAction: () => {
              handleisAlertOpenListaSeleccionable();
            },
          },
        ]}
      >
        <FormikProvider value={formikInventario!}>
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} md={12} mt={2}>
              <Typography
                variant="h5"
                color="primary"
                gutterBottom
                sx={{ color: "#004c93", textAlign: "center" }}
              >
                Registrar Producto
              </Typography>
            </Grid>
            <br />
            <Grid item xs={6} sm={6}>
              <TextField
                id="clave"
                fullWidth
                label={`${intl.formatMessage({ id: "input_clave" })}`}
                variant="standard"
                name="clave"
                value={formikInventario.values.clave || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("clave", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.clave && Boolean(formikInventario.errors.clave)}
                helperText={formikInventario.touched.clave && formikInventario.errors.clave}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("clave"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("clave"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("clave"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("clave"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="nombre"
                fullWidth
                label={`${intl.formatMessage({ id: "input_nombre" })}`}
                variant="standard"
                name="nombre"
                value={formikInventario.values.nombre || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("nombre", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.nombre && Boolean(formikInventario.errors.nombre)}
                helperText={formikInventario.touched.nombre && formikInventario.errors.nombre}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("nombre"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("nombre"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("nombre"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("nombre"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="precio"
                fullWidth
                label={`${intl.formatMessage({ id: "input_precio" })}`}
                variant="standard"
                name="precio"
                type="number"
                value={formikInventario.values.precio || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("precio", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.precio && Boolean(formikInventario.errors.precio)}
                helperText={formikInventario.touched.precio && formikInventario.errors.precio}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("precio"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("precio"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("precio"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("precio"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_unidad_medida"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_unidad_medida" })} *`}
                variant="standard"
                name="id_unidad_medida"
                value={formikInventario.values.id_unidad_medida || ""}
                disabled={!unidadesMedida || unidadesMedida.length === 0}
                helperText={
                  !unidadesMedida || unidadesMedida.length === 0
                    ? intl.formatMessage({ id: "sin_unidades_medida_registradas" })
                    : formikInventario.touched.id_unidad_medida &&
                    formikInventario.errors.id_unidad_medida
                }
                error={
                  formikInventario.touched.id_unidad_medida &&
                  Boolean(formikInventario.errors.id_unidad_medida)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_unidad_medida", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_unidad_medida"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_unidad_medida"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_unidad_medida"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_unidad_medida"),
                  },
                }}
              >
                {unidadesMedida?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_categoria"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_categoria" })} *`}
                variant="standard"
                name="id_categoria"
                value={formikInventario.values.id_categoria || ""}
                disabled={!categorias || categorias.length === 0}
                helperText={
                  !categorias || categorias.length === 0
                    ? intl.formatMessage({ id: "sin_categorias_registradas" })
                    : formikInventario.touched.id_categoria && formikInventario.errors.id_categoria
                }
                error={
                  formikInventario.touched.id_categoria &&
                  Boolean(formikInventario.errors.id_categoria)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_categoria", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_categoria"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_categoria"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_categoria"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_categoria"),
                  },
                }}
              >
                {categorias?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_ubicacion"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_ubicacion" })} *`}
                variant="standard"
                name="id_ubicacion"
                value={formikInventario.values.id_ubicacion || ""}
                disabled={!ubicaciones || ubicaciones.length === 0}
                helperText={
                  !ubicaciones || ubicaciones.length === 0
                    ? intl.formatMessage({ id: "sin_ubicaciones_registradas" })
                    : formikInventario.touched.id_ubicacion && formikInventario.errors.id_ubicacion
                }
                error={
                  formikInventario.touched.id_ubicacion &&
                  Boolean(formikInventario.errors.id_ubicacion)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_ubicacion", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_ubicacion"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_ubicacion"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_ubicacion"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_ubicacion"),
                  },
                }}
              >
                {ubicaciones?.map((option) => (
                  <MenuItem key={option.id_ubicacion} value={option.id_ubicacion}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                id="id_tipo_producto"
                select
                fullWidth
                label={`${intl.formatMessage({ id: "select_tipo_producto" })} *`}
                variant="standard"
                name="id_tipo_producto"
                value={formikInventario.values.id_tipo_producto || ""}
                disabled={!tipoProductos || tipoProductos.length === 0}
                helperText={
                  !tipoProductos || tipoProductos.length === 0
                    ? intl.formatMessage({ id: "sin_tipos_producto_registrados" })
                    : formikInventario.touched.id_tipo_producto &&
                    formikInventario.errors.id_tipo_producto
                }
                error={
                  formikInventario.touched.id_tipo_producto &&
                  Boolean(formikInventario.errors.id_tipo_producto)
                }
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("id_tipo_producto", value);
                }}
                InputProps={{
                  style: { padding: "5px" },
                }}
                onBlur={formikInventario.handleBlur}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("id_tipo_producto"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("id_tipo_producto"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("id_tipo_producto"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("id_tipo_producto"),
                  },
                }}
              >
                {tipoProductos?.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="cantidad"
                fullWidth
                label={`${intl.formatMessage({ id: "input_cantidad" })}`}
                variant="standard"
                name="cantidad"
                type="number"
                value={formikInventario.values.cantidad || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("cantidad", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={
                  formikInventario.touched.cantidad && Boolean(formikInventario.errors.cantidad)
                }
                helperText={formikInventario.touched.cantidad && formikInventario.errors.cantidad}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("cantidad"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("cantidad"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("cantidad"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("cantidad"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="maximos"
                fullWidth
                label={`${intl.formatMessage({ id: "input_maximos" })}`}
                variant="standard"
                name="maximos"
                type="number"
                value={formikInventario.values.maximos || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("maximos", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.maximos && Boolean(formikInventario.errors.maximos)}
                helperText={formikInventario.touched.maximos && formikInventario.errors.maximos}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("maximos"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("maximos"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("maximos"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("maximos"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="minimos"
                fullWidth
                label={`${intl.formatMessage({ id: "input_minimos" })}`}
                variant="standard"
                name="minimos"
                type="number"
                value={formikInventario.values.minimos || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("minimos", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={formikInventario.touched.minimos && Boolean(formikInventario.errors.minimos)}
                helperText={formikInventario.touched.minimos && formikInventario.errors.minimos}
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("minimos"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("minimos"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("minimos"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("minimos"),
                  },
                }}
              />
            </Grid>
            <Grid item xs={6} sm={6} sx={{ position: "relative" }}>
              <TextField
                id="punto_reorden"
                fullWidth
                label={`${intl.formatMessage({ id: "input_punto_reorden" })}`}
                variant="standard"
                name="punto_reorden"
                type="number"
                value={formikInventario.values.punto_reorden || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  formikInventario.setFieldValue("punto_reorden", value);
                }}
                onBlur={formikInventario.handleBlur}
                error={
                  formikInventario.touched.punto_reorden &&
                  Boolean(formikInventario.errors.punto_reorden)
                }
                helperText={
                  formikInventario.touched.punto_reorden && formikInventario.errors.punto_reorden
                }
                sx={{
                  "& .MuiInputLabel-root": {
                    color: getFieldColorInventario("punto_reorden"),
                  },
                  "& .MuiInput-underline:after": {
                    borderBottomColor: getFieldColorInventario("punto_reorden"),
                  },
                  "& .MuiInput-underline:before": {
                    borderBottomColor: getFieldColorInventario("punto_reorden"),
                  },
                  "& .MuiInputBase-input": {
                    color: getFieldColorInventario("punto_reorden"),
                  },
                }}
              />
            </Grid>
          </Grid>
        </FormikProvider>
      </ModalComponent>
      {/* LISTA DE PRODUCTOS EXISTENTES */}
      <ModalComponent
        esFullScreen
        handleClose={handleisAlertCloseListaSeleccionable}
        isOpen={isAlertOpenListaSeleccionable}
        key={"alerta-lista-seleccionable"}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12} md={12} mt={2}>
            <Typography
              variant="h4"
              color="primary"
              gutterBottom
              sx={{ color: "#004c93", textAlign: "center" }}
            >
              Lista de productos existentes
            </Typography>
            <Typography variant="button" gutterBottom sx={{ color: "#00", textAlign: "center" }}>
              Selecciona el producto que quieras registrar a la requisición
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <InventarioTabla
              filas={filasInventario}
              cargando={procesando}
              mostrarEstatus
              busqueda
              onVerDetalle={setProductoDetalle}
              mensajeVacio={intl.formatMessage({ id: "general_sin_registros" })}
            />
          </Grid>
        </Grid>
      </ModalComponent>
      {/* MODAL DE DETALLE DE PRODUCTO */}
      <ModalComponent
        handleClose={() => setProductoDetalle(null)}
        isOpen={productoDetalle !== null}
        key={"alerta-detalle-producto"}
        actions={[
          {
            title: "Actualizar producto",
            icon: <IconUserEdit stroke={2} />,
            color: "#0047AB",
            hoverColor: "#003a8c",
            textColor: "#ffffff",
            handleAction: async () => {
              if (!productoDetalle) return;
              const exito = await actualizarProductoEnRequisicion(productoDetalle);
              if (exito) setProductoDetalle(null);
            },
          },
        ]}
      >
        {productoDetalle && (
          <Grid container spacing={2} style={{ textAlign: "center" }}>
            <Grid item xs={12} mt={2}>
              <Typography variant="h5" color="primary" gutterBottom sx={{ color: "#004c93" }}>
                {productoDetalle.nombre}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <InventarioDetalleContenido fila={productoDetalle} />
            </Grid>
          </Grid>
        )}
      </ModalComponent>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default RequisicionIndividual;
